/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

export default `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <path style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;
    text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;
    mix-blend-mode:normal" d="M 3 2 A 1.0001 1.0001 0 0 0 2 3 L 2 47 A 1.0001 1.0001 0 0 0 3 48 L 47 48 A 1.0001 1.0001 
    0 0 0 48 47 L 48 3 A 1.0001 1.0001 0 0 0 47 2 L 3 2 z M 4 4 L 24 4 L 24 24 L 4 24 L 4 4 z M 26 4 L 46 4 L 46 24 
    L 26 24 L 26 4 z M 4 26 L 24 26 L 24 46 L 4 46 L 4 26 z M 26 26 L 46 26 L 46 46 L 26 46 L 26 26 z" 
    font-weight="400" font-family="sans-serif" white-space="normal" overflow="visible"/>
</svg>`;